(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-cards"] && !Shopify.designMode) return;
  try {
    
class FeatureCardsCarousel extends HTMLElement {
  #resizeObserver;
  #track = null;
  #controls = null;
  #prev = null;
  #next = null;
  #cards = [];
  #dots = [];

  #autoplayInterval = null;
  #autoplayDelay = 100;
  #autoplayEnabled = false;
  #isStaticGrid = false;

  connectedCallback() {
    this.#track = this.querySelector('.feature-cards__grid');
    this.#controls = this.querySelector('.feature-cards__controls');
    this.#prev = this.querySelector('.feature-cards__nav-button--prev');
    this.#next = this.querySelector('.feature-cards__nav-button--next');
    this.#cards = Array.from(this.querySelectorAll('.feature-cards__card'));
    this.#dots = Array.from(this.querySelectorAll('.feature-cards__dot'));

    if (!this.#track) return;

    this.#isStaticGrid = this.dataset.forceGrid === 'true';

    if (this.#isStaticGrid) {
      this.#updateState();
      return;
    }

    this.#autoplayEnabled = Boolean(this.#track.dataset.autoplayEnabled) || false;
    this.#autoplayDelay = (Number(this.#track.dataset.autoplaySpeed) || this.#autoplayDelay) * 1000;

    this.#track.addEventListener('scroll', this.#handleScroll, { passive: true });
    
    this.#prev?.addEventListener('click', () => {
      this.#handlePrev();
      this.#startAutoplay();
    });
    this.#next?.addEventListener('click', () => {
      this.#handleNext();
      this.#startAutoplay();
    });

    this.#track.addEventListener('mouseenter', () => this.#stopAutoplay());
    this.#track.addEventListener('mouseleave', () => this.#startAutoplay());

    this.#track.addEventListener('touchstart', () => this.#stopAutoplay(), { passive: true });
    this.#track.addEventListener('touchend', () => this.#startAutoplay(), { passive: true });
    this.#track.addEventListener('touchcancel', () => this.#startAutoplay(), { passive: true });

    for (const [index, dot] of this.#dots.entries()) {
      dot.addEventListener('click', () => {
        this.#scrollToCard(index);
        this.#startAutoplay();
      });
    }

    this.#resizeObserver = new ResizeObserver(() => this.#updateState());
    this.#resizeObserver.observe(this.#track);

    this.#updateState();
    this.#startAutoplay();
  }

  disconnectedCallback() {
    this.#track?.removeEventListener('scroll', this.#handleScroll);
    this.#resizeObserver?.disconnect();
    this.#stopAutoplay();
  }

  #startAutoplay() {
    if (this.#isStaticGrid || !this.#autoplayEnabled) return;
    this.#stopAutoplay();
    
    this.#autoplayInterval = setInterval(() => {
      if (!this.#track) return;
      
      const max = this.#track.scrollWidth - this.#track.clientWidth;
      const current = this.#track.scrollLeft;

      if (current >= max - 2) {
        this.#track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.#scrollByStep(1);
      }
    }, this.#autoplayDelay);
  }

  #stopAutoplay() {
    if (!this.#autoplayEnabled && !this.#isStaticGrid) {
      this.#prev?.removeEventListener('click', this.#handlePrev);
      this.#next?.removeEventListener('click', this.#handleNext);
    }

    if (this.#autoplayInterval) {
      clearInterval(this.#autoplayInterval);
      this.#autoplayInterval = null;
    }
  }

  #handleScroll = () => {
    this.#updateButtonStates();
    this.#updateActiveDot();
  };

  #handlePrev = () => {
    this.#scrollByStep(-1);
  };

  #handleNext = () => {
    this.#scrollByStep(1);
  };

  #scrollByStep(direction) {
    if (!this.#track) return;

    const card = this.#cards[0];
    if (!card) return;

    const styles = getComputedStyle(this.#track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    const step = card.getBoundingClientRect().width + gap;

    this.#track.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  #scrollToCard(index) {
    if (!this.#track) return;

    const card = this.#cards[index];
    if (!card) return;

    const trackRect = this.#track.getBoundingClientRect();
    const cardRect = card.getBoundingClientRect();

    this.#track.scrollBy({
      left: cardRect.left - trackRect.left,
      behavior: 'smooth',
    });
  }

  #updateState() {
    if (this.#controls) {
      this.#controls.hidden = this.#isStaticGrid || !this.#isScrollable();
    }
    if (!this.#isStaticGrid) {
      this.#updateButtonStates();
      this.#updateActiveDot();
    }
  }

  #isScrollable() {
    if (!this.#track) return false;
    return this.#track.scrollWidth - this.#track.clientWidth > 1;
  }

  #updateButtonStates() {
    if (!this.#track || !this.#prev || !this.#next) return;

    const max = this.#track.scrollWidth - this.#track.clientWidth;
    const current = this.#track.scrollLeft;

    this.#prev.disabled = current <= 1;
    this.#next.disabled = current >= max - 1;
  }

  #updateActiveDot() {
    if (!this.#track || !this.#cards.length || !this.#dots.length) return;

    const trackRect = this.#track.getBoundingClientRect();
    const trackCenter = trackRect.left + trackRect.width / 2;

    let activeIndex = 0;
    let minDistance = Infinity;

    for (let i = 0; i < this.#cards.length; i++) {
      const cardRect = this.#cards[i].getBoundingClientRect();
      const cardCenter = cardRect.left + cardRect.width / 2;
      const distance = Math.abs(cardCenter - trackCenter);

      if (distance < minDistance) {
        minDistance = distance;
        activeIndex = i;
      }
    }

    for (let i = 0; i < this.#dots.length; i++) {
      const isActive = i === activeIndex;
      this.#dots[i].classList.toggle('feature-cards__dot--active', isActive);
      this.#dots[i].setAttribute('aria-current', isActive ? 'true' : 'false');
    }
  }
}

if (!customElements.get('feature-cards-carousel')) {
  customElements.define('feature-cards-carousel', FeatureCardsCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["persistent-hero-cta"] && !Shopify.designMode) return;
  try {
    
  /**
   * Persistent hero CTA element.
   * Visible on load, hides when the footer comes into view.
   */
  class PersistentHeroCta extends HTMLElement {
    /** @type {IntersectionObserver | undefined} */
    #footerObserver;

    connectedCallback() {
      this.classList.add('persistent-hero-cta--active');
      this.#setupFooterObserver();
    }

    disconnectedCallback() {
      this.#footerObserver?.disconnect();
    }

    #setupFooterObserver() {
      const footerGroup =
        document.querySelector('#shopify-section-group-footer-group') ||
        document.querySelector('footer');

      if (!footerGroup) return;

      this.#footerObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            this.classList.toggle('persistent-hero-cta--active', !entry.isIntersecting);
          }
        },
        { threshold: 0, rootMargin: '0px 0px 80px 0px' }
      );

      this.#footerObserver.observe(footerGroup);
    }
  }

  if (!customElements.get('persistent-hero-cta')) {
    customElements.define('persistent-hero-cta', PersistentHeroCta);
  }

  } catch(e) { console.error(e); }
})();
})();
